import { render, staticRenderFns } from "./salaryManual.vue?vue&type=template&id=2e338e9c&scoped=true&"
import script from "./salaryManual.vue?vue&type=script&lang=js&"
export * from "./salaryManual.vue?vue&type=script&lang=js&"
import style0 from "./salaryManual.vue?vue&type=style&index=0&id=2e338e9c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e338e9c",
  null
  
)

export default component.exports